import { useEffect } from 'react'
import { ResetCallAtbackType } from './usePaginationRevised'
import { useAppDispatch, useTypedSelector } from '../../stateStore'
import { reduxServices } from '../../reducers/reduxServices'

export default function usePaginationParent(
  parentRoute: string,
  relatedRoute: string,
  resetPaginationAt: ResetCallAtbackType,
  callback?: () => void,
): void {
  const dispatch = useAppDispatch()
  const allCachedPages = useTypedSelector(
    reduxServices.app.selectors.selectAllCachedPage,
  )
  const routeOrigin = useTypedSelector(
    reduxServices.app.selectors.selectReRouteOrigin,
  )
  const recentUrl = useTypedSelector(reduxServices.app.selectors.getOriginUrl)

  useEffect(() => {
    return () => {
      dispatch(reduxServices.app.actions.setOriginUrl(parentRoute))
    }
  }, [])

  useEffect(() => {
    if (routeOrigin === relatedRoute && relatedRoute !== '') {
      const parentPage = allCachedPages.find(
        (cache) => cache.locationPath === parentRoute,
      )

      if (resetPaginationAt) {
        resetPaginationAt(
          parentPage?.pageNumber || 1,
          parentPage?.pageSize || 20,
        )
      }
    }
  }, [routeOrigin])

  useEffect(() => {
    if (recentUrl !== parentRoute && callback) {
      resetPaginationAt(1, 20)
      callback()
    }
  }, [recentUrl])
}
